import React from 'react'
import './Button.scss'
import PropTypes from 'prop-types'
import Icon from '../../components/Icon/Icon'
import { Link } from 'react-router-dom'

const Button = ({ type, align, onClick, iconName, link, children }) => {
  return link ? (
    <Link to={link} className={`Button ${type} ${align}`}>
      {children}
      {iconName && (
        <span className="Button__icon">
          <Icon name={iconName} />
        </span>
      )}
    </Link>
  ) : (
    <button className={`Button ${type} ${align}`} onClick={onClick}>
      {children}
      {iconName && (
        <span className="Button__icon">
          <Icon name={iconName} />
        </span>
      )}
    </button>
  )
}

Button.defaultProps = {
  type: 'primary',
  align: 'left',
  onClick: null,
}

Button.propTypes = {
  type: PropTypes.string,
  onClick: PropTypes.func,
  iconName: PropTypes.string,
  align: PropTypes.string,
  children: PropTypes.string,
  link: PropTypes.string,
}

export default Button
